import axiosWithToken from "axiosWithToken";
import { NotificationCountResponse, NotificationListItem } from "./types";

const baseURL2 = process.env.REACT_APP_BASEURL2;

export const getNotificationsCount =
  async (): Promise<NotificationCountResponse> => {
    try {
      const response = await axiosWithToken.get<NotificationCountResponse>(
        `${baseURL2}api/notifications/unread-count`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching unread notification count:", error);
      throw error;
    }
  };

export const getNotifications = async (): Promise<NotificationListItem[]> => {
  try {
    const response = await axiosWithToken.get<NotificationListItem[]>(
      `${baseURL2}api/notifications`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markAllNotificationsRead = async (): Promise<void> => {
  try {
    const response = await axiosWithToken.patch(
      `${baseURL2}api/notifications/read`
    );
    return response.data;
  } catch (error) {
    console.error("Error marking all notifications as read:", error);
    throw error;
  }
};

export const markNotificationRead = async (id: string): Promise<void> => {
  try {
    const response = await axiosWithToken.patch(
      `${baseURL2}api/notifications/${id}/read`
    );
    return response.data;
  } catch (error) {
    console.error("Error marking  notifications as read:", error);
    throw error;
  }
};
